"use strict";

exports.__esModule = true;
exports.featureManager = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FeatureManager = /*#__PURE__*/function () {
  function FeatureManager() {
    this.features = {
      fullscreenRedesign: {
        title: 'New fullscreen design',
        releaseDate: Date.parse('2017-09-25T12:00:00.000Z')
      },
      spacingCalculation: {
        title: 'Improve spacing calculation',
        releaseDate: Date.parse('2017-08-29T11:27:29.000Z')
      },
      fixedColumnsInMasonry: {
        title: 'Allow fixed number of columns in Masonry layout',
        releaseDate: Date.parse('2018-05-24T18:00:00.000Z')
      },
      mobileSettings: {
        title: 'Separate mobile and desktop setting',
        releaseDate: Date.parse('2018-12-18T12:00:50.054Z')
      }
    };
    this.freezeDate = new Date();
    this.updateFeatures();
  }

  var _proto = FeatureManager.prototype;

  _proto.updateFeatures = function updateFeatures() {
    var _this = this;

    this.supports = Object.entries(this.features).reduce(function (obj, _ref) {
      var _objectSpread2;

      var feature = _ref[0],
          releaseDate = _ref[1].releaseDate;
      return _objectSpread({}, obj, (_objectSpread2 = {}, _objectSpread2[feature] = _this.freezeDate >= releaseDate, _objectSpread2));
    });
  };

  _createClass(FeatureManager, [{
    key: "freezeDate",
    get: function get() {
      return this._dateCreated || new Date();
    },
    set: function set(date) {
      if (typeof date === 'object' && typeof date.getTime === 'function') {
        this._dateCreated = date;
        this.updateFeatures();
      }
    }
  }]);

  return FeatureManager;
}();

var featureManager = new FeatureManager();
exports.featureManager = featureManager;